import { render } from "./SideOrder.vue?vue&type=template&id=39e1f3d8&scoped=true&ts=true"
import script from "./SideOrder.vue?vue&type=script&lang=ts"
export * from "./SideOrder.vue?vue&type=script&lang=ts"

import "./SideOrder.vue?vue&type=style&index=0&id=39e1f3d8&scoped=true&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e1f3d8"]])

export default __exports__